var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEndocrinology(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    d: "M48.5 11.5h28v29h11c-.166 7.008 0 14.008.5 21 9.276 6.566 15.609 15.233 19 26a344.478 344.478 0 011 51c-9.324 31.642-29.99 43.309-62 35-15.181-6.515-24.514-17.848-28-34-.667-16-.667-32 0-48 2.7-12.757 9.367-22.757 20-30 .5-6.992.666-13.992.5-21a60.94 60.94 0 0011-.5 207.407 207.407 0 01-1-28.5z",
    opacity: 0.898
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#050100",
    d: "M99.5 11.5h17a60.93 60.93 0 00.5 11c3.333-1.333 6.667-1.333 10 0a145.05 145.05 0 01.5 17h-11v10h-17v-10h-11c-.166-5.676 0-11.343.5-17 3.333-1.333 6.667-1.333 10 0a60.94 60.94 0 00.5-11z",
    opacity: 0.844
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f94800",
    d: "M105.5 17.5h5v10c3.125.98 6.458 1.313 10 1v4c-3.542-.313-6.875.02-10 1v10h-5v-10h-11v-5h11v-11z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6c737a",
    d: "M55.5 17.5v47h15c-5.14.988-10.474 1.321-16 1a576.578 576.578 0 011-48z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#741f02",
    d: "M105.5 17.5v11h-11c3.125-.98 6.458-1.313 10-1-.313-3.542.021-6.875 1-10z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#a72d00",
    d: "M110.5 27.5h11v6h-11c3.125-.98 6.458-1.313 10-1v-4c-3.542.313-6.875-.02-10-1z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#090806",
    d: "M156.5 37.5c4.521-.108 7.688 1.892 9.5 6 .5 7.993.666 15.993.5 24 7.435.598 11.935 4.598 13.5 12a289.106 289.106 0 010 34c-1.274 5.214-3.607 9.881-7 14a98.432 98.432 0 00-.5 14h10v35h-65v-35h11a72.367 72.367 0 00-.5-12 113.627 113.627 0 01-10-15 256.122 256.122 0 010-32c1.661-5.547 5.161-7.88 10.5-7 3.393-6.009 8.059-7.342 14-4 2.118-1.446 4.451-2.113 7-2a142.776 142.776 0 011.5-28 59.835 59.835 0 015.5-4z",
    opacity: 0.903
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#efc390",
    d: "M44.5 46.5h5a25.87 25.87 0 01-1 10 6.845 6.845 0 01-4 1v-11z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#edc390",
    d: "M76.5 46.5h5a36.874 36.874 0 01-1 12l-3-2a25.87 25.87 0 01-1-10z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#b8c3d1",
    d: "M55.5 17.5h15v47h-15v-47z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#636970",
    d: "M65.5 44.5h-5v4h5c-1.765.961-3.765 1.295-6 1v-6c2.235-.295 4.235.039 6 1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#020202",
    d: "M65.5 44.5v4h-5v-4h5z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#050606",
    d: "M60.5 33.5h5v5h-5v-5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#0b0c0d",
    d: "M60.5 22.5h5v5h-5v-5z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#3c3c3c",
    d: "M77.5 62.5c-.973 2.448-1.306 5.115-1 8-9.182.327-18.182-.007-27-1h26a16.869 16.869 0 011-8c.607.124.94.457 1 1z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3bf8e",
    d: "M160.5 46.5c-1.188-1.184-2.355-1.184-3.5 0a1391.6 1391.6 0 01-1.5 53c-.167-18.336 0-36.67.5-55 2.501-1.556 4.001-.89 4.5 2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4dda4",
    d: "M160.5 46.5v53h6v-26c3.67-.173 6.17 1.493 7.5 5 .667 12 .667 24 0 36-2.512 4.361-5.012 8.694-7.5 13-.977 2.787-1.31 5.787-1 9h-31a40.914 40.914 0 00-.5-9l-10-14a240.38 240.38 0 010-31c1.667-2.667 3.333-2.667 5 0a145.05 145.05 0 01.5 17h5c-.166-7.674 0-15.34.5-23 1.333-1.333 2.667-1.333 4 0 .5 7.66.666 15.326.5 23h5c-.166-7.34 0-14.674.5-22 1.396-2.027 3.062-2.36 5-1 .5 7.66.666 15.326.5 23h5a1391.6 1391.6 0 001.5-53c1.145-1.184 2.312-1.184 3.5 0z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ebebeb",
    d: "M49.5 69.5c8.818.993 17.818 1.327 27 1-.306-2.885.027-5.552 1-8 13.038 5.539 21.204 15.205 24.5 29 .667 16 .667 32 0 48-1.183 3.026-2.35 6.026-3.5 9a490.227 490.227 0 01-11 9.5 15.645 15.645 0 00-4 2.5c-.607-.124-.94-.457-1-1a46.107 46.107 0 006-5.5 19.885 19.885 0 00-4-3.5c-5.528 6.262-12.528 9.596-21 10-.951 1.419-1.285 3.085-1 5-13.71-.188-24.71-5.688-33-16.5a2.429 2.429 0 00-2-.5 63.686 63.686 0 01-3.5-9 366.773 366.773 0 011-53c4.776-11.61 12.943-19.61 24.5-24v7z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#030404",
    d: "M31.5 83.5h63v31h-63v-31z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#39c3fb",
    d: "M36.5 90.5h51v18h-51v-18z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f181e",
    d: "M44.5 96.5h5v6h-5v-6z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f191f",
    d: "M60.5 96.5h5v6h-5v-6z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#010608",
    d: "M81.5 97.5v4h-5v-4h5z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#1a607c",
    d: "M81.5 97.5h-5v4h5c-1.765.961-3.765 1.295-6 1v-6c2.235-.295 4.235.039 6 1z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#40d9ff",
    d: "M36.5 90.5v-1h52v20h-52v-1h51v-18h-51z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#217396",
    d: "M36.5 89.5a702.832 702.832 0 0153-1v22a702.727 702.727 0 01-53-1h52v-20h-52z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#494949",
    d: "M31.5 83.5v31h63a1024.55 1024.55 0 01-64 1c-.328-10.846.006-21.513 1-32z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#090909",
    d: "M40.5 123.5h17v21a145.05 145.05 0 01-17-.5c-9.298-6.913-9.298-13.747 0-20.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#070707",
    d: "M68.5 123.5c6.425-.37 12.758.13 19 1.5 4.678 5.106 5.178 10.606 1.5 16.5-1.42.96-2.92 1.793-4.5 2.5-5.323.499-10.656.666-16 .5v-21z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#8f99a9",
    d: "M42.5 129.5h9v9h-9c-3.063-1.96-3.73-4.627-2-8 .457-.798 1.124-1.131 2-1z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#666c78",
    d: "M42.5 129.5c3.125-.979 6.458-1.313 10-1v11c-3.542.313-6.875-.021-10-1h9v-9h-9z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#8992a2",
    d: "M73.5 128.5c3.35-.165 6.683.002 10 .5 4 3.333 4 6.667 0 10-3.317.498-6.65.665-10 .5v-11z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7bc8b",
    d: "M166.5 127.5v14h-6v3h-5v-3h-21v-5h31c-.31-3.213.023-6.213 1-9z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#ededed",
    d: "M155.5 144.5h5v3h8v23h-33c-1.13-7.254-1.296-14.587-.5-22a108.41 108.41 0 0120.5-1v-3z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#55524f",
    d: "M166.5 141.5c-1.419.951-3.085 1.284-5 1v4c5.195-.321 10.195.013 15 1h-16v-6h6z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#e7e7e7",
    d: "M129.5 147.5v23h-5v-23h5z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#999",
    d: "M129.5 147.5h-5v23h5c-1.765.961-3.765 1.295-6 1v-25c2.235-.295 4.235.039 6 1z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#aeb7c3",
    d: "M168.5 147.5h8v24a420.766 420.766 0 01-41-1h33v-23z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5c0cd",
    d: "M27.5 148.5a2.429 2.429 0 012 .5c8.29 10.812 19.29 16.312 33 16.5-.285-1.915.049-3.581 1-5v5c6.985.004 13.319-1.996 19-6 .06.543.393.876 1 1a15.645 15.645 0 014-2.5 490.227 490.227 0 0011-9.5c-9.561 17.155-24.228 24.321-44 21.5-12.5-2.9-21.5-10.067-27-21.5z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#0f0f0f",
    d: "M82.5 159.5c-5.681 4.004-12.015 6.004-19 6v-5c8.472-.404 15.472-3.738 21-10a19.885 19.885 0 014 3.5 46.107 46.107 0 01-6 5.5z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndocrinology);
export default __webpack_public_path__ + "static/media/endocrinology.3ead5265.svg";
export { ForwardRef as ReactComponent };